define('models/template/assignment',[
    'underscore', 'backbone', 'moment', 'utils',
    // services
    'services/api',
], function(
    _, Backbone, moment, U,
    // services
    API
) {

    var MTemplateAssignment = Backbone.Epoxy.Model.extend({
        idAttribute: '_id',
        urlRoot: API.url("templates/assignments/"),

        defaults: function() {
            return {
                startDate: API.formatDate(moment())
            };
        },

        computeds: {
            daysRemaining: {
                deps: ['endDate'],
                get: function(endDate) {
                    endDate = moment(endDate).diff(moment().format('YYYY-MM-DD'), 'days');
                    return endDate > 0 ? endDate : 0;
                },
            },
        },

        setStartDate: function(dayId) {
            return this.reset({ startDate: API.formatDate(dayId) });
        },

        setTemplate: function(templateId) {
            return this.set('template', templateId);
        },

    });

    // Return the model for the module
    return MTemplateAssignment;
});

